import { Shield } from "lucide-react";
import logo from "../../assets/images/mobile-logo.svg";

export const PrivacyPolicyHeader = () => {
  return (
      <header className="bg-[#0b1f5e] text-white text-center">
        <div className="mx-auto max-w-[1080px] px-7 pb-8 pt-4">
          {/* Brand */}
          <div className="mb-[10px]">
            <img src={logo} alt="" width={70} />
          </div>
          <Shield className="bg-[#ffffff36] rounded-full p-3 mx-auto" size={70} />
          <h1 className="text-[30px] font-bold tracking-[-0.6px] max-[640px]:text-2xl">
            Privacy Policy
          </h1>
    
          <p className="mt-2 max-w-[600px] text-sm text-[#c3cdec] mx-auto">
            JBCC is an internal enterprise application for authorised employees
            and contractors of Jai Bharat Construction Company.
            Accounts are provisioned by a company administrator and cannot be
            self-registered.
          </p>

          {/* Meta */}
          <div className="mt-[18px] flex flex-wrap gap-[9px] justify-center">
            <span className="rounded-[7px] border border-white/15 bg-white/[0.07] px-[11px] py-[5px] text-xs text-[#dbe2f7]">
              Version <strong className="font-semibold text-white">1.0</strong>
            </span>

            <span className="rounded-[7px] border border-white/15 bg-white/[0.07] px-[11px] py-[5px] text-xs text-[#dbe2f7]">
              Effective{" "}
              <strong className="font-semibold text-white">
                7 August 2026
              </strong>
            </span>

            <span className="rounded-[7px] border border-white/18 bg-white/[0.07] px-[11px] py-[5px] text-xs text-[#dbe2f7]">
              Web · Android · iOS
            </span>
          </div>
        </div>
      </header>
  )
}
